import React, { useContext } from 'react'
import { PageContext } from '../context/PageContext'
import NavigationTwoSlides from './navigation-two-slides'
import TopNavBar from './topNavBar'
import Navigation from './navigation'

export default function Header() {
    const { isNavOpen, toggleNavOpen } = useContext(PageContext)
    return (
        <div className="w3-row">
            <TopNavBar isNavOpen={isNavOpen} toggleNavOpen={toggleNavOpen} />
            <Navigation />
            <NavigationTwoSlides
                isNavOpen={isNavOpen}
                toggleNavOpen={toggleNavOpen}
            />
        </div>
    )
}
